import React, { Component } from 'react';
import '../LoginPage/LoginForm.css';
import {Redirect} from 'react-router-dom'
import {auth} from '../../../../Config/Firebase'

import './LoginForm.css'
import HavenLogo from '../../../Images/MyHavenLogo.png'
import {Link} from 'react-router-dom'
import firebase from 'firebase/app'
import Referrals from '../../../Images/Referrals.png'
//redux 
import { connect } from 'react-redux'
import { hideLoading } from '../../../../Actions/loadingAction'
import PasswordResetEmailForm from './PasswordResetEmailForm';

let db = firebase.firestore();
let havenRef = db.collection("Users");

class Register extends Component {
    constructor(props){
        super(props);
        this.state = {
            email: '',
            password: '',
            first: '',
            last: '',
            phone: '',
           showPasswordResetForm: false,
           register_title: "Register For Referrals"
        
        };
    }
    
    componentWillMount(){
        if(this.props.is_authenticated_prop === null){
            setTimeout(() => {
                this.props.hideLoading();
            }, 1000);   
        }

      console.log(window.location.href)
    }

   
//login  to firebase
register = (event) => {
    event.preventDefault()

    auth.createUserWithEmailAndPassword(this.state.email, this.state.password).catch((error) =>{            
        console.log(error.code);
        
        if(error.code === "auth/email-already-in-use") {
            this.setState({
                register_title: "The email is in use."
            })
        }

        if(error.code === null) {
            this.setState({
                register_title: "Registered! Going to MyHaven Referrals."
            })
        }
    }).then(()=>{
        var user = auth.currentUser;

        var data ={
            Email: user.email,
            Address: "",
            Contract: "",
            FirstName: this.state.first,
            JobStatus: "",
            LastName: this.state.last,
            Monitoring: "",
            NEM: "",
            Permit: "",
            PhoneNumber: this.state.phone,
            PowrGuard: "",
            Role: "Referrals",
            SalesRep: "",
            SalesRepEmail: "",
            SalesType: "",
            SitePlans: "",
            SystemSize: "",
            ZipCode: "",
        };

        var setDoc = havenRef.doc(user.uid).set(data);
    })
}


render() { 

    const { from } = this.props.location.state || { from: { pathname: "/dashboard" } };
    if (this.props.is_authenticated_prop !== null) {
        return <Redirect to={from} />;
    }

    return ( 

                <div className="page">
                        <div className="container-fluid login-form-div">
                        <div className="row">
                            <div className="col-xl-6 leftSideLogin">
                                <form className="login-form">
                            
                                    <li>
                                        <h3 id="formTitle">{this.state.register_title}</h3>
                                        <hr/>
                                    </li>
                                <br/>
                                    <li>
                                        <input type="text" id="firstInput" placeholder="First Name" onChange={(event) => this.setState({ first: event.target.value})} required/>
                                    </li>

                                    <li>
                                        <input type="text" id="lastInput" placeholder="Last Name" onChange={(event) => this.setState({ last: event.target.value})} required/>
                                    </li>

                                    <li>
                                        <input type="text" id="phoneInput" placeholder="Phone Number" onChange={(event) => this.setState({ phone: event.target.value})} required/>
                                    </li>

                                    <li>
                                        <input type="email" id="emailInput" placeholder="Email" onChange={(event) => this.setState({ email: event.target.value})} required/>
                                    </li>

                                    <li>
                                        <input type="password" id="passwordInput" placeholder="Password" onChange={(event) => this.setState({ password: event.target.value})} required/>
                                    </li>
                                    <li>
                                        <button type="submit"className="btn btn-primary large" onClick={this.register}>Register</button>
                                    </li>
                                    <li id="bottom-nav"><Link to="/referrals">Back To Login</Link></li>
                                </form>
                        
                            </div>
                            <div className="d-none d-lg-block col-xl-6 rightSideLogin">
                            <div className="rightPanelDiv">
                                    <img src={Referrals} alt="Image of MyHaven" width="400px"/>
                                </div>
                            </div>
                        </div>

                    </div>

                    </div>
      
 
            
         )
    }
}
 

const mapStateToProps = state => ({
    is_authenticated_prop: state.is_authenticated.is_authenticated,
    email: state.firebase.email,
    loading: state.loading.loading
    
  })

  const mapDispatchToProps = (dispatch) => {
    return {
      
        hideLoading: () => dispatch(hideLoading("SHOW_LOADING"))
    }
  }

  export default connect(mapStateToProps, mapDispatchToProps) (Register);
  
  




// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/LoginPage/Register.jsx